var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"loader",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onInputChange}}),_c('v-btn',{staticClass:"loader-button",attrs:{"small":"","text":"","outlined":"","color":"blue-grey lighten-3"},on:{"click":_vm.onBtnClick}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-table ")]),_vm._v(" load ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }